import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components'
import { Variant } from './Toast.types'

interface WrapperProps {
  variant: Variant
}

const BaseWrapper = styled.div(
  ({ theme: { radii, fonts, fontSizes, fontWeights, shadows } }) => css`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: 8px;
    border-radius: ${radii.xxlarge};

    font-family: ${fonts.primary};
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.regular};

    box-shadow: ${shadows.boxShadow.outer};

    a,
    .link {
      color: inherit;
      text-decoration: underline;
    }

    a:hover,
    .link:hover {
      color: inherit;
    }
  `
)

const defaultWrapperCss = ({ colors }: DefaultTheme) => css`
  color: ${colors.foreground.secondary[2]};
  background-color: ${colors.background.secondary[1]};
  border: 1px solid ${colors.border[1]};
`

const positiveWrapperCss = ({ colors }: DefaultTheme) => css`
  color: ${colors.foreground.primary[1]};
  background-color: ${colors.state.positive};
`

const negativeWrapperCss = ({ colors }: DefaultTheme) => css`
  color: ${colors.foreground.primary[1]};
  background-color: ${colors.state.negative};
`

const variantWrapperCss = (
  theme: DefaultTheme,
  variant: Variant
): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (variant) {
    case 'default':
      return defaultWrapperCss(theme)
    case 'positive':
      return positiveWrapperCss(theme)
    case 'negative':
      return negativeWrapperCss(theme)
  }
}

export const Wrapper = styled(BaseWrapper)<WrapperProps>(({ theme, variant }) =>
  variantWrapperCss(theme, variant)
)

export const ChildrenWrapper = styled.div`
  display: flex;
  align-items: center;

  padding-left: 12px;
  white-space: pre-wrap;
`

export const CloseWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 32px;

  cursor: pointer;
`
